<template>
  <div class="auth-layout">
    <zoom-center-transition
      :duration="pageTransitionDuration"
      mode="out-in"
    >
      <router-view></router-view>
    </zoom-center-transition>
  </div>
</template>

<script>
import { ZoomCenterTransition } from 'vue2-transitions';

export default {
  components: {
    ZoomCenterTransition
  },
  data() {
    return {
      pageTransitionDuration: 200
    };
  },
  methods: {
    removeBackgroundColor() {
      document.body.classList.remove('bg-default');
    }
  },
  mounted() {
    this.removeBackgroundColor();
  },
  beforeDestroy() {
    this.removeBackgroundColor();
  }
};
</script>

<style lang="scss">
.auth-layout {
  min-height: 100vh;
}

// Reset body background for auth pages
body.bg-default {
  background: transparent !important;
}
</style>
